export class YtPlayerDialog {
  VideoId: string;
}
